export default function(entity, property) {
    if(!entity){
        throw  new TypeError('Invalid arguments');
    }
    if(entity.properties.hasOwnProperty(property)){
        return entity.properties[property].value;
    } else {
        return undefined;
    }
}